var _defs, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCompassV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 1200,
    viewBox: "0 0 1200 1200",
    xmlSpace: "preserve",
    id: "SVGRoot",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1"
  }, "\r\ng.prefab path {\r\n  vector-effect:non-scaling-stroke;\r\n  -inkscape-stroke:hairline;\r\n  fill: none;\r\n  fill-opacity: 1;\r\n  stroke-opacity: 1;\r\n  stroke: #00349c;\r\n}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(254.23727,45.7627)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 3.88028,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      paintOrder: "markers fill stroke"
    },
    id: "path2",
    cx: 345.76273,
    cy: 554.2373,
    r: 345.76273
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    style: {
      fill: "#ffffff",
      strokeWidth: 4.0523,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      paintOrder: "markers fill stroke"
    },
    d: "M 162.52319,845.68579 254.96155,527.08017 347.3999,208.47457 440.14088,526.73325 532.88185,844.99192 347.3999,796.07584 Z"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "219.612px",
      lineHeight: 0,
      fontFamily: "'Tw Cen MT'",
      InkscapeFontSpecification: "'Tw Cen MT'",
      textAlign: "start",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      fill: "#000000",
      strokeWidth: 16.8003,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      paintOrder: "markers fill stroke"
    },
    x: 530.72784,
    y: 146.79617,
    id: "text3"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan3",
    x: 530.72784,
    y: 146.79617,
    style: {
      fontWeight: "bold",
      strokeWidth: 16.8003
    }
  }, "U")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompassV2);
export default __webpack_public_path__ + "static/media/icon_compass_v2.2ed0eb22d1424cccc3f94146a504b51f.svg";
export { ForwardRef as ReactComponent };